import React from "react";
import { toUpperCaseNoAccent } from 'utils/stringHelper';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

const AddMontantMiniRetourExcluDialog = ({ onClose, onClickSave, niveaux, open }) => {

    /** Hook niveau */
    const [niveau, setNiveau] = React.useState(0);

    /** Hook code */
    const [code, setCode] = React.useState('');

    /** Handler pour ajouter le montant mini */
    const addMontantMini = () => {
        // On récupère le niveau
        let objNiveau = niveaux.find(n => n.id === niveau);

        onClickSave(code, objNiveau);
        onClose();
    };

    return (
        <Dialog open={open}>
            <DialogTitle>Nouvelle exclusion montant mini au retour</DialogTitle>

            <DialogContent>
                <Stack spacing={2} mt={1}>

                    <TextField
                        id="niveau"
                        name="niveau"
                        label="Niveau"
                        required
                        select
                        SelectProps={{
                            required: true,
                            value: niveau,
                            onChange: e => setNiveau(e.target.value)
                        }}
                    >
                        {niveaux.map(n =>
                            <MenuItem key={n.id} value={n.id}>
                                {n.libelle}
                            </MenuItem>)
                        }
                    </TextField>

                    <TextField
                        id="code"
                        name="code"
                        label={"Code"}
                        required
                        fullWidth
                        placeholder="Saisir un code"
                        value={code}
                        onChange={e => setCode(toUpperCaseNoAccent(e.target.value))}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={addMontantMini}
                    variant="contained"
                    color="secondary"
                    disabled={!code}
                >
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddMontantMiniRetourExcluDialog;
